import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'

import styles from './styles.module.scss'

interface IConversationCardProps {
  name: ReactNode
  value?: ReactNode
  placeholder: string
}
export const ConversationCard = observer(({ name, value, placeholder }: IConversationCardProps) => (
  <div className={styles.conversationCard}>
    <div className={styles.conversationCardRow}>
      <span className={styles.conversationCardName}>{name}</span>
      <span className={styles.conversationCardValue}>
        {value ?? <span className={styles.conversationCardPlaceholder}>{placeholder}</span>}
      </span>
    </div>
  </div>
))
